import { useMerchant } from "./context/merchant";
import { ApolloProvider } from "@apollo/client";
import { client } from "./api/graphql";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import NewOrderModal from "./modals/new-order";
import LoginScreen from "./features/auth/LoginScreen";
import MerchantSideMenu from "./components/sidebar";
import MerchantHistoryScreen from "./features/history/HistoryScreen";
import MerchantProductsEditScreen from "./features/products/ProductsScreen";
import MerchantAddDiscountScreen from "./features/discounts/DiscountsScreen";
import CategoryManageScreen from "./features/categories/CategoriesScreen";
import PrivateRoute from "./features/auth/PrivateRoute";
import AuthExpiredOverlay from "./features/auth/AuthExpiredOverlay";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import MerchantOrdersScreen from "./screens/orders";
import RequestDriverScreen from "./features/delivery/RequestDriverScreen";
import DeliveryHistoryScreen from "./features/delivery/DeliveryHistoryScreen";
import ShareScreen from "./screens/share";
import CaptureImagesScreen from "./features/products/CaptureImagesScreen";

export default function App() {
  const { newOrderModalOpen, setNewOrderModalOpen, initialLoading } =
    useMerchant();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");

    const isOnLoginPage = location.pathname === "/";
    const isOnPrivatePage = location.pathname.startsWith("/menu");

    if (!token && isOnPrivatePage) {
      navigate("/");
    }
    if (token && isOnLoginPage) {
      navigate("/menu/orders");
    }
  }, [navigate, location.pathname]);

  return (
    <>
      {initialLoading ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <ApolloProvider client={client}>
          <NewOrderModal
            show={newOrderModalOpen}
            handleClose={() => setNewOrderModalOpen(false)}
            onClick={() => {}}
          />
          <Routes>
            <Route path="/" element={<LoginScreen />} />
            <Route path="/share/:type/:id" element={<ShareScreen />} />
            <Route
              path="/menu/*"
              element={
                <PrivateRoute>
                  <MerchantSideMenu />
                </PrivateRoute>
              }
            >
              <Route path="orders" element={<MerchantOrdersScreen />} />
              <Route path="history" element={<MerchantHistoryScreen />} />
              <Route path="request-driver" element={<RequestDriverScreen />} />
              <Route
                path="edit-products"
                element={<MerchantProductsEditScreen />}
              />
              <Route
                path="add-discount"
                element={<MerchantAddDiscountScreen />}
              />
              <Route path="add-category" element={<CategoryManageScreen />} />
              <Route path="capture-images" element={<CaptureImagesScreen />} />
              <Route
                path="delivery-history"
                element={<DeliveryHistoryScreen />}
              />
            </Route>
          </Routes>
        </ApolloProvider>
      )}

      {/* Нэвтрэлт дууссан үеийн бүтэн дэлгэцийн хаалт — ГАНЦ удаа mount.
          initialLoading-оос гадна байрлуулсан нь: эхний getMerchantMe 401
          авахад цацагдах event-ийг ч алдахгүй (spinner → app шилжихэд
          state нь хадгалагдана). */}
      <AuthExpiredOverlay />
    </>
  );
}
